// extracted by mini-css-extract-plugin
module.exports = {"error":"PersonalData_error_3vIzv","policy":"PersonalData_policy_TeJJv"};